import { useState } from "react";

export type SortDir = "asc" | "desc";

export interface SortState {
  sortBy: string | null;
  sortDir: SortDir;
}

// Shared click behavior for admin list column sorting: clicking an unsorted column sorts it
// ascending; clicking the already-active column flips direction; clicking a different column
// switches to it, starting ascending.
export function useAdminSort(initial: SortState = { sortBy: null, sortDir: "asc" }) {
  const [sort, setSort] = useState<SortState>(initial);

  const toggleSort = (key: string) => {
    setSort((prev) => (prev.sortBy === key
      ? { sortBy: key, sortDir: prev.sortDir === "asc" ? "desc" : "asc" }
      : { sortBy: key, sortDir: "asc" }));
  };

  return { sort, toggleSort };
}
